import { Box, Toolbar } from '@mui/material'
import * as React from 'react'
import { Outlet } from 'react-router-dom'
import BrockAppBar from '../navigation/BrockAppBar'
import BrockDrawer from '../navigation/BrockDrawer'

type LoggedInLayoutProps = {
	showDrawer?: boolean
}

const LoggedInLayout = ({ showDrawer = true }: LoggedInLayoutProps) => { 
	const [drawerOpen, setDrawerOpen] = React.useState(true)
	return (
	<Box sx={{ height: '100vh', width: '100%', maxWidth: '100%' }}>
		<BrockAppBar showAccountInfo={showDrawer} />
		{showDrawer && <BrockDrawer open={drawerOpen} setOpen={setDrawerOpen}/>}
		<Box
			component='main'
			sx={{
				paddingTop: '64px',
				left: drawerOpen ? '248px' : '30px',
				top: '0px',
				position: 'relative',
				height: 'auto',
				width: drawerOpen ? 'calc(100% - 248px)' : 'calc(100% - 30px)',
				overflowY: 'auto',
				transition: (theme) =>
					theme.transitions.create(["left", "width"], {
					  easing: theme.transitions.easing.sharp,
					  duration: theme.transitions.duration.standard,
				}),
			}}
		>
			<Outlet />
		</Box>
	</Box>
)}

export default LoggedInLayout
